import { Button, Divider, Flex, Tag } from "antd";
import { useTranslation } from "react-i18next";

import Paragraph from "antd/es/typography/Paragraph";
import CustomCard from "../../../../components/CustomCard";
import { CartOutline } from "../../../../constants/iconExports";
import { orderType } from "../../../../types/order";
import { formatNumber } from "../../../../utils/formatNumber";
import { getDateTime } from "../../../../utils/getDate";
import OrderAccordion from "./OrderAccordion";
import React from "react";

type OrderListProps = {
  orderURL: string;
  data: orderType[];
  completed?: boolean;
  showStatus?: boolean;
}

const OrderList: React.FC<OrderListProps> = (props: OrderListProps) => {
  const { orderURL, data, completed = false, showStatus = true } = props;
  const { t } = useTranslation();
  if (data.length === 0) {
    return (
      <Flex vertical align="center" justify="flex-end" className="h-[284px]">
        <CartOutline color={'var(--app-foreground-color)'} />
        <Paragraph className="h3-bold" style={{ color: 'var(--app-foreground-color)' }}>
          {t("No order found")}
        </Paragraph>
      </Flex>
    );
  }

  return (
    <Flex vertical gap={"12px"} className="p-4 w-full">
      {data.map((order, index) => (
        <CustomCard shadow={false} key={`${order.order_number}${index}`}>
          <Flex
            vertical
            style={{ padding: "28px 16px 28px 16px" }}
            gap={"16px"}
          >
            <Flex vertical gap={"8px"}>
              {showStatus && (
                <Tag
                  style={{
                    padding: "2px 8px 2px 8px",
                    color: completed ? "#425A70" : "var(--app-foreground-color)",
                    backgroundColor: completed ? "#E7EBEF" : "var(--app-lighten-foreground-color)",
                    border: "none",
                  }}
                  className="w-fit rounded-[20px] note-medium"
                >
                  {t(order.status)}
                </Tag>
              )}

              <Flex vertical gap={"4px"}>
                <Flex gap={"20px"} justify="space-between" align="center">
                  <Paragraph className="h3-bold text-o-body text-ellipsis">
                    {order.order_number || "-"}
                  </Paragraph>
                  <Flex gap={"1px"} align="center" className="mb-auto">
                    {order.amount ? (
                      <>
                        <Paragraph className="h3-bold text-primary" style={{ color: `var(--app-foreground-color)` }}>
                          {order?.currency === 'JPY' ? t("{{ currency }}", { currency: order?.currency}) : order?.currency}
                          {order?.currency === 'JPY' ? "" : " "}
                          {order?.currency === 'JPY' ? t("{{ amount }}", {amount: formatNumber(order?.amount)}) : formatNumber(order?.amount)}
                        </Paragraph>
                      </>
                    ) : (
                      <Paragraph
                        className="h3-bold"
                        style={{ color: `var(--app-foreground-color)` }}
                      >
                        -
                      </Paragraph>
                    )}
                  </Flex>
                </Flex>
                <Paragraph className="note-regular text-o-description">
                  {getDateTime(order.order_date)}
                </Paragraph>
              </Flex>
            </Flex>
            <Divider className="border-lineColor m-0" />
            <OrderAccordion
              key={index}
              order={order}
            />
          </Flex>
        </CustomCard>
      ))}
      {data.length > 0 && orderURL && (
        <Flex justify="center">
          <Button
            style={{
              padding: "8px 12px 8px 12px",
              color: 'var(--app-foreground-color)',
              borderColor: 'var(--app-foreground-color)'
            }}
            className="h-[36px] w-[136px] rounded-[4px]"
            ghost
            type="primary"
            href={orderURL}
          >
            {t("Load more orders")}
          </Button>
        </Flex>
      )}
    </Flex>
  );
};
export default OrderList;
